import Vue from 'vue'
import { hasAuthToken, openLoginModal } from './loginGate'

/** 全局「余额与账单」弹窗状态 */
export const balanceBillingGate = Vue.observable({
  visible: false,
  /** 登录成功后自动打开 */
  pendingOpen: false
})

export function openBalanceBillingModal() {
  balanceBillingGate.visible = true
}

export function closeBalanceBillingModal() {
  balanceBillingGate.visible = false
}

/** 侧栏用户入口：已登录开余额弹窗，未登录先登录 */
export function requestBalanceBillingModal() {
  if (!hasAuthToken()) {
    balanceBillingGate.pendingOpen = true
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.setItem('balanceBillingPendingOpen', '1')
    }
    openLoginModal()
    return
  }
  balanceBillingGate.pendingOpen = false
  if (typeof sessionStorage !== 'undefined') {
    sessionStorage.removeItem('balanceBillingPendingOpen')
  }
  openBalanceBillingModal()
}

export function clearBalanceBillingPending() {
  balanceBillingGate.pendingOpen = false
  if (typeof sessionStorage !== 'undefined') {
    sessionStorage.removeItem('balanceBillingPendingOpen')
  }
}

/** 登录后整页刷新时，恢复「待打开余额弹窗」 */
export function restoreBalanceBillingPendingAfterLogin() {
  if (typeof sessionStorage === 'undefined') return false
  if (sessionStorage.getItem('balanceBillingPendingOpen') !== '1') return false
  if (!hasAuthToken()) return false
  clearBalanceBillingPending()
  openBalanceBillingModal()
  return true
}
